import React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Info } from "lucide-react";

// Tap/click-friendly contextual explainer (never hover-only) for accessibility.
export function InfoTip({ title, text, testid, className = "" }) {
  const id = testid || `info-${(title || "").toLowerCase().replace(/\s+/g, "-")}`;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" aria-label={`What is ${title}?`} data-testid={id}
          className={`inline-flex items-center justify-center h-6 w-6 rounded-full text-muted-foreground hover:text-navy hover:bg-secondary transition-colors align-middle ${className}`}>
          <Info size={14} strokeWidth={2} />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" collisionPadding={12} className="w-64 max-w-[calc(100vw-24px)] rounded-xl">
        <p className="font-medium text-ink text-sm mb-1">{title}</p>
        <p className="text-slatey leading-relaxed text-[13px]">{text}</p>
      </PopoverContent>
    </Popover>
  );
}

// Shared glossary so wording stays consistent everywhere.
export const GLOSSARY = {
  safe_to_spend: {
    title: "Safe to Spend",
    text: "The estimated amount available after accounting for your upcoming commitments and protected reserve.",
  },
  commitment_ratio: {
    title: "Commitment Ratio",
    text: "The share of your monthly income already promised to recurring commitments. Lower is healthier.",
  },
  protected_reserve: {
    title: "Protected Reserve",
    text: "Money you want COMMITMENTT to keep aside when estimating what is safe for you to spend.",
  },
  committed: {
    title: "Committed This Month",
    text: "The total of all commitments falling due within the current month.",
  },
  due_this_cycle: {
    title: "Due This Cycle",
    text: "Payments scheduled between now and your next income date.",
  },
  income_before_cycle: {
    title: "Income Before Cycle",
    text: "Income expected to arrive before your next set of commitments is due.",
  },
  upcoming: {
    title: "Upcoming Commitments",
    text: "Payments scheduled to leave your account soon, based on each commitment's due date.",
  },
  recurring: {
    title: "Recurring Commitment",
    text: "A payment that repeats on a schedule — weekly, monthly, quarterly, half-yearly or yearly.",
  },
};
